import { Flex, type IconComponent } from '@backend/lib-design-system';

import { Text } from '~/components/FiltersPanel/FiltersPanel.styles';

type FiltersHeaderInfoProps = { text: string; Icon: IconComponent };

export const FiltersHeaderInfo = ({ Icon, text }: FiltersHeaderInfoProps) => (
  <Flex.Row space="xs" flexWrap="nowrap" alignItems="flex-end">
    <Icon size="l" />
    <Text>{text}</Text>
  </Flex.Row>
);
